import AddStocktakeCommentModal from './AddStocktakeCommentModal.js'
import AddToStocktakeModal from './AddToStocktakeModal.js'
import CreateStocktakeModal from './CreateStocktakeModal.js'
import EditStocktakeParamModal from './EditStocktakeParamModal.js'
import PrintStocktakeModal from './PrintStocktakeModal.js'
import RemoveFromStocktakeModal from './RemoveFromStocktakeModal.js'
import StocktakeDetailFilterModal from './StocktakeDetailFilterModal/index.js'
import StocktakeListFilterModal from './StocktakeListFilterModal/index.js'
import StocktakeModal from './StocktakeModal.js'
import StocktakeReconcileModal from './StocktakeReconcileModal.js'
import StocktakeSettingsModal from './StocktakeSettingsModal.js'
import UpdateStocktakeStatusModal from './UpdateStocktakeStatusModal.js'

export default function Modals() {
  return (
    <>
      <AddStocktakeCommentModal />
      <AddToStocktakeModal />
      <CreateStocktakeModal />
      <EditStocktakeParamModal />
      <PrintStocktakeModal />
      <RemoveFromStocktakeModal />
      <StocktakeDetailFilterModal />
      <StocktakeListFilterModal />
      <StocktakeModal />
      <StocktakeReconcileModal />
      <StocktakeSettingsModal />
      <UpdateStocktakeStatusModal />
    </>
  )
}
